export default __webpack_public_path__ + "static/circle_w.98abea8f896037a98d1578a7651062ed.svg";